import { UI_THEME_NEW } from '~/themes/types'
import { openLoginPrompt } from '~/composables/useLoginPrompt'

/** Path + query + hash halaman saat ini (mis. /web/games/mobile-legend). */
export function getLoginReturnUrl() {
  return window.location.pathname + window.location.search + window.location.hash
}

/**
 * Redirect ke halaman login Laravel dengan URL kembali.
 * Backend harus menyimpan query `redirect` ke session `url.intended`
 * agar `redirect()->intended('/profile')` bekerja setelah login.
 */
export function redirectToLogin(returnUrl = getLoginReturnUrl()) {
  const loginUrl = new URL('/login', window.location.origin)
  loginUrl.searchParams.set('redirect', returnUrl)
  window.location.assign(loginUrl.toString())
}

/** Redirect ke halaman profil di aplikasi utama (di luar base `/web/`). */
export function redirectToProfile() {
  window.location.assign(new URL('/profile', window.location.origin).href)
}

/** Redirect ke OAuth Google. Path `/auth/google` di luar base `/web/`. */
export function redirectToGoogleLogin(returnUrl = getLoginReturnUrl()) {
  const url = new URL('/auth/google', window.location.origin)
  url.searchParams.set('redirect', returnUrl)
  window.location.assign(url.toString())
}

let loginPromptOpen = false

export function promptLoginRequired(returnUrl = getLoginReturnUrl(), options = {}) {
  if (document.documentElement.dataset.uiTheme === UI_THEME_NEW) {
    openLoginPrompt({
      returnUrl,
      onConfirm: options.onConfirm,
    })
    return
  }

  if (loginPromptOpen) {
    return
  }

  loginPromptOpen = true

  ElMessageBox.confirm(
    'Silahkan login terlebih dahulu',
    'Login Diperlukan',
    {
      confirmButtonText: 'Login',
      cancelButtonText: 'Batal',
      type: 'warning',
    },
  )
    .then(() => {
      options.onConfirm?.()
      redirectToLogin(returnUrl)
    })
    .catch(() => {})
    .finally(() => {
      loginPromptOpen = false
    })
}
